import { DesktopOsType, OsType } from '../../constants'

export default {
  isAndroid (state) {
    return state.isMobileBrowser === true && state.mobileOs === OsType.Android
  },

  isIOS (state) {
    return state.isMobileBrowser === true && state.mobileOs === OsType.Apple
  },

  isMac (state) {
    return state.desktopOs === DesktopOsType.Mac
  },

  isWindows (state) {
    return state.desktopOs === DesktopOsType.Windows
  }
}
